import type {
  QuestionImagepickerModelDataChoice,
  SurveyAnswerRecord,
  SurveyConfig,
  SurveyImageAnswerValue,
} from '../../types'

/**
 * surveyAnswerとsurveyConfigから、画像のURLを抽出
 */
export function extractImageUrls(surveyConfigJson: SurveyConfig, surveyAnswer: SurveyAnswerRecord): string[] {
  const imageUrls: string[] = []

  try {
    surveyConfigJson.elements?.forEach((element) => {
      const { type, name } = element

      // 画像選択
      if (type === 'imagepicker') {
        const choices = (element).choices
        const selectedValue = surveyAnswer[name]
        if (selectedValue) {
          const selectedValues = Array.isArray(selectedValue) ? selectedValue : [selectedValue]
          selectedValues.forEach((value) => {
            const choice = choices?.find((choice: QuestionImagepickerModelDataChoice) => choice.value === value)
            if (choice?.imageLink) {
              imageUrls.push(choice.imageLink)
            }
          })
        }
      }

      // 画像アップロード
      if (type === 'file') {
        addFileImagesToArray(surveyAnswer, name, imageUrls)
      }

      // panel内のfile要素を処理
      if (type === 'panel' && element.elements) {
        const panelAnswer = surveyAnswer[name] as SurveyAnswerRecord | undefined
        if (panelAnswer) {
          element.elements.forEach((panelElement) => {
            const { type: panelElementType, name: panelElementName } = panelElement
            // 現状、panel内で画像を扱えるのはfile質問のみ
            if (panelElementType === 'file') {
              addFileImagesToArray(panelAnswer, panelElementName, imageUrls)
            }
          })
        }
      }
    })
  } catch (error) {
    console.error('Failed to parse surveyConfigJson:', error)
    return []
  }

  return imageUrls
}

/**
 * file質問から画像URLを抽出して配列に追加する
 */
function addFileImagesToArray(surveyAnswer: SurveyAnswerRecord, name: string, imageUrls: string[]): void {
  const uploadedFiles = surveyAnswer[name] as SurveyImageAnswerValue[] | undefined
  if (uploadedFiles) {
    uploadedFiles.forEach((file) => {
      if (file.content !== '') {
        imageUrls.push(file.content)
      }
    })
  }
}
